import { render } from "./RecargaConsultasView.vue?vue&type=template&id=35f22ba1&scoped=true"
import script from "./RecargaConsultasView.vue?vue&type=script&lang=js"
export * from "./RecargaConsultasView.vue?vue&type=script&lang=js"

import "./RecargaConsultasView.vue?vue&type=style&index=0&id=35f22ba1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f22ba1"]])

export default __exports__